export function loadMediaKey(mediaId) {
  return ['media/' + mediaId]
}
